/*
 * i18n.js — the label/translate helper used by the entity field-type registry
 * and the concrete entity configs (the recovered `t`/`l` from
 * ./_createAssigner.js: `label = $t(<key>)`).
 *
 * Reconstructed from lacak.io deployed behavior; app-specific contract verbatim
 * (registry labels/titles are i18n KEYS resolved through this `t()`), internal
 * impl re-authored.
 *
 * In the running app a shared vue-i18n instance is injected once at boot via
 * `setI18n(this.$i18n)`; until then (and in unit context) `t()` degrades to a
 * humanized fallback of the key's last segment so forms still render.
 */

let _i18n = null;

/** Wire the app's vue-i18n instance (call once from the root component). */
export function setI18n(i18n) {
  _i18n = i18n || null;
}

/** Humanize a dotted i18n key -> "Field types text" style fallback text. */
function humanizeKey(key) {
  const leaf = String(key).split('.').pop() || String(key);
  const words = leaf.replace(/[_-]+/g, ' ').trim();
  return words ? words.charAt(0).toUpperCase() + words.slice(1) : String(key);
}

/**
 * t(key[, params]) — resolve an i18n key.
 * Delegates to vue-i18n when present (honoring `$te` existence checks),
 * otherwise returns a humanized fallback.
 */
export function t(key, params) {
  if (key == null) return '';
  if (_i18n && typeof _i18n.t === 'function') {
    if (typeof _i18n.te === 'function' && !_i18n.te(key)) return humanizeKey(key);
    return params !== undefined ? _i18n.t(key, params) : _i18n.t(key);
  }
  return humanizeKey(key);
}

/** te(key) — does the translation exist? (used by schema title resolution). */
export function te(key) {
  if (_i18n && typeof _i18n.te === 'function') return _i18n.te(key);
  return false;
}

export default { t, te, setI18n };
